import { FC, useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext, Currency } from '@repo-level/core-front';

import { Button } from 'components/buttons';
import {
  mapCurrencyFlags,
  mapCurrencyFullName,
  mapCurrencySymbol,
} from 'helpers/currency';
import { AddonsContext } from 'contexts/addons';

import { ScCurrenciesBlock } from './styled';
import { ScCurrenciesItem, ScCurrenciesItems } from '../styled';

export const CurrenciesAvailableBlock = () => {
  const { t } = useTranslation('deposits');

  const { wallets } = useContext(AuthContext);
  const { enableCurrencies } = useContext(AddonsContext);

  const notActiveCurrencies = useMemo(() => {
    const d = wallets.map(({ currency }) => currency);
    return enableCurrencies.filter(({ code }) => !d.includes(code));
  }, [enableCurrencies, wallets]);

  return (
    <ScCurrenciesBlock>
      <div className="title">{t('editCurrency.otherCurrencies')}</div>
      <ScCurrenciesItems>
        {notActiveCurrencies.map((currency) => (
          <CurrencyItem key={currency.code} {...currency} />
        ))}
      </ScCurrenciesItems>
    </ScCurrenciesBlock>
  );
};

const CurrencyItem: FC<Currency> = ({ code }) => {
  const { t } = useTranslation();

  const [pending, setPending] = useState(false);
  const { changeUserWallet } = useContext(AuthContext);

  const icon = useMemo(() => mapCurrencyFlags[code], [code]);

  return (
    <ScCurrenciesItem>
      <div className="content">
        {icon && <img src={icon} alt="" />}
        <div>
          {mapCurrencySymbol[code].symbol} | {mapCurrencyFullName[code]}
        </div>
      </div>

      <Button
        greenTransparent
        medium
        autoPaddingHorizontal
        onClick={() => {
          changeUserWallet(code);
          setPending(true);
        }}
        pending={pending}
      >
        {t('glossary:add')}
      </Button>
    </ScCurrenciesItem>
  );
};
